import React from 'react';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useState } from 'react';
import { useEffect } from 'react';
import {
    gethotelcleaners, saveRooster, getIssuefromCleaningAssignment, updateIssue, getView, getCleaningtasks
} from "../dbconnector/connector";
import { setErrorMessage, setMessage, clearMessage, settopMessage, cleartopMessage } from "../tools/errorhandling";
import EmployeeRoosterNode from '../customNodes/EmployeeRoosterNode';
import Button from 'react-bootstrap/Button';
import { CgCloseR } from "react-icons/cg";
import { json } from 'react-router-dom';
import { getfilesurl, downloadfile } from '../tools/filehandler';
import ImageViewer from './ImageViewer';
import moment from 'moment'
import { Tooltip } from 'react-tooltip'
import { GoTasklist } from 'react-icons/go';

const AssignmentDetailNode = ({ rights, t, assignmentDisabled, data, events }) => {


    const [history, setHistory] = useState({})
    const [picturenameArray, setPicturenameArray] = useState([]);
    const [dndpicturenameArray, setdndPicturenameArray] = useState([]);
    const [QApicturenameArray, setQAPicturenameArray] = useState([]);
    const [generalservicestasks, setGeneralservicestasks] = useState([]);
    const optionstypes = {
        0: t("Blijver"),
        1: t("Vertrekker"),
        2: t("Flitskamer"),
        3: t("dailyclean"),
        4: t("weeklyClean"),
        5: t("finalClean")
    };
    const [extratasksduration, setExtratasksduration] = useState(0);
    const [extrataskdescription, setExtrataskdescription] = useState("no extra tasks");



    // useEffect(() => {
    //     setHistory([])
    //     setPicturenameArray([])
    // })
    useEffect(() => {
        resetalldivs()
        if (data !== undefined && data.id !== undefined && document.getElementById("QualityControlNode").style.display === 'none') {
            //console.log("data A :", data)
            setExtratasksduration(0)
            setExtrataskdescription("no extra tasks")
            setGeneralservicestasks([])
            if (data.hotel_Id !== undefined)
                Getgeneralservicestasks(data.hotel_Id)
            else if (data.hotel_id !== undefined)
                Getgeneralservicestasks(data.hotel_id)
        }
    }, [data])

    useEffect(() => {
        //console.log("generalservicestasks B :", generalservicestasks)
        if (data !== undefined && data.id !== undefined && generalservicestasks.length > 0) {
            calcpayedtasks(data);
            document.getElementById("FullscreenBlocker").style.display = "block";
            document.getElementById("RotatinglinesText").innerText = "Detail gegegevens wordt opgehaald, even geduld"
            //settopMessage( "Afbeeldingen worden opgehaald, even geduld")
            getView("assignmentdetails", "id", data.id).then((result) => {
                if (result.status === 200) {
                    setHistory([])
                    result.json().then((histories) => {
                        if (histories.length > 0) {
                            histories.forEach((cleaningHistory) => {
                                if (data.id === cleaningHistory.id) {
                                    setHistory(cleaningHistory)
                                    document.getElementById("FullscreenBlocker").style.display = "none";
                                }
                            })
                        } else {
                            events.handleCancel()
                            setErrorMessage("Er zijn geen geschiedenisgegevens gevonden.");
                            document.getElementById("FullscreenBlocker").style.display = "none";
                        }
                    })
                } else {
                    setErrorMessage(result.statusText);
                    document.getElementById("FullscreenBlocker").style.display = "none";
                }
            })
        }
    }, [generalservicestasks])

    const resetalldivs = () => {
        // document.getElementById("employeedetails").style.display = "none";
        document.getElementById("dndtimegrouplabel").style.display = "none"
        document.getElementById("dndtimegroup").style.display = "none"
        document.getElementById("noDND").style.display = "block"

        document.getElementById("issuestimegrouplabel").style.display = "none"
        document.getElementById("issuestimegroup").style.display = "none"
        document.getElementById("noissues").style.display = "block"

        document.getElementById("QAtimegrouplabel").style.display = "none"
        document.getElementById("QAtimegroup").style.display = "none"
        document.getElementById("noQA").style.display = "block"

        document.getElementById("cleaningdatagroup").style.display = "none"
        document.getElementById("cleaningdata").style.display = "none"
    }

    useEffect(() => {
        setPicturenameArray([])
        if (history.id) {
            settopMessage("Afbeeldingen worden opgehaald, even geduld")

            const response = getfilesurl(2, history.issue_id)
            response.then(res => {
                if (res.status === 200) {
                    res.json().then(urls => {
                        setPicturenameArray(urls);
                    })
                } else {
                    cleartopMessage()
                }
            })
            response.catch((error) => {
                cleartopMessage()
                setErrorMessage(error)
            })


            // getfilesurl(2, history.issue_id).then((urls) => {
            //     setPicturenameArray(urls);
            // })
        }
        setdndPicturenameArray([])
        if (history.id) {
            settopMessage("Afbeeldingen DND worden opgehaald, even geduld")
            const response = getfilesurl(4, history.id)
            response.then(res => {
                if (res.status === 200) {
                    res.json().then(urls => {
                        setdndPicturenameArray(urls);
                    })
                } else {
                    cleartopMessage()
                }
            })
            response.catch((error) => {
                cleartopMessage()
                setErrorMessage(error)
            })
        }

        setQAPicturenameArray([])

        if (history.id) {
            document.getElementById("cleaningdatagroup").style.display = "grid"
            document.getElementById("cleaningdata").style.display = "block"
            settopMessage("Afbeeldingen QA worden opgehaald, even geduld")


            const response = getfilesurl(3, history.id)
            response.then(res => {
                if (res.status === 200) {
                    res.json().then(urls => {
                        setQAPicturenameArray(urls);
                    })
                } else {
                    cleartopMessage()
                }
            })
            response.catch((error) => {
                cleartopMessage()
                setErrorMessage(error)
            })

            // getfilesurl(3, history.id).then((urls) => {
            //     setQAPicturenameArray(urls);
            // })
        }
        if (history.dndTime !== null) {
            document.getElementById("dndtimegrouplabel").style.display = "grid"
            document.getElementById("dndtimegroup").style.display = "grid"
            document.getElementById("noDND").style.display = "none"
        }
        if (history.issue_id !== null) {
            document.getElementById("issuestimegrouplabel").style.display = "grid"
            document.getElementById("issuestimegroup").style.display = "grid"
            document.getElementById("noissues").style.display = "none"
        }
        if (history.QAopmerkingen !== null) {
            document.getElementById("QAtimegrouplabel").style.display = "grid"
            document.getElementById("QAtimegroup").style.display = "grid"
            document.getElementById("noQA").style.display = "none"
        }
    }, [history])


    const Getgeneralservicestasks = (hotelid) => {
        if (hotelid) {

            getCleaningtasks(hotelid, 1).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setGeneralservicestasks(body.items)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        }
    }

    const calcpayedtasks = (item) => {
        setExtratasksduration(0)
        setExtrataskdescription("no extra tasks")
        let duration = 0
        let description = ""
        if (item.multiple !== "{}") {

            let multipletasks = JSON.parse(item.multiple)

            const filteredkeys = Object.keys(multipletasks)
            filteredkeys.forEach((key) => {

                const taskitem = generalservicestasks.find((taak) => taak.Id === Number(key))
                if (taskitem) {
                    var tasktijd = (60 / Number(taskitem.taskDuration) * Number(multipletasks[key]))
                    duration = Number(duration) + tasktijd
                    description = "[" + Number(multipletasks[key]) + " x '" + taskitem.taskDescription + "': " + tasktijd.toFixed(0) + " min extra ], " + description
                }
                setExtratasksduration(duration)
                setExtrataskdescription(description)

            })
        } else if (item.tasks !== "") {
            setExtratasksduration(0)
            setExtrataskdescription("")
            const taskitem = generalservicestasks.find((taak) => taak.Id === Number(item.tasks))
            if (taskitem) {
                duration = 60 / Number(taskitem.taskDuration)
                description = "1 x '" + taskitem.taskDescription + "': " + duration.toFixed(0) + " min extra"
            }
            setExtratasksduration(duration)
            setExtrataskdescription(description)
        }
    }

    const handleCancel = (e) => {
        events.startdrag(null, false, e)
        setPicturenameArray([]);
        setdndPicturenameArray([]);
        setQAPicturenameArray([]);
        setHistory([]);
        events.handleCancel(e);
    }


    return (
        <>
            <div id="assignmentDetailsNode" className='assignmenthistorydiv'>
                <div className='formcaptionhistory' ><div onMouseDown={(e) => events.startdrag("assignmentDetailsNode", true, e)} onMouseUp={(e) => events.startdrag(null, false, e)}>{t('cleaninghistory')} </div><div onClick={handleCancel} ><CgCloseR className='closer' /></div></div>
                <div className="AssignCleaningformhistory">
                    <br></br>
                    <label id="cleaningdata" className='formtitleGroupBox formtitleGroupBoxtopmargin'>{t('Kuistaakgegevens')}</label>
                    <div id="cleaningdatagroup" className="AssignCleaninggroupboxhistory groupbox_history">
                        <div className='groupbox_history_4rows'>
                            <label className='simplelabel'>
                                {t('creationdate')}
                            </label>
                            <input id="creationdate" name="creationdate" className='inputviewhistory' type='text' value={moment(history.creationdate).format("DD/MMM/yyyy")} disabled>
                            </input>
                            <label className='labelhotel'>
                                {t('HotelName')}
                            </label>
                            <input id="hotelname" name="hotelname" className='inputviewhistory' type='text' value={history.hotelname} disabled>
                            </input>
                            <label className='labelhotel'>
                                {t('Kamernr')}
                            </label>
                            <input id="title" name="title" className='inputviewhistory' type='text' value={history.title} disabled>
                            </input>
                            <label className='labelhotel' style={history.roomnumber !== "default cleaningassignment" ? { visibility: "visible" } : { visibility: "hidden" }}>
                                {t('kuistype')}
                            </label>
                            {/* //{optionstypes[cleaningtype.type] || "Type not recognised"} {cleaningtype.description} */}
                            <input id="cleaningtypedescription" name="cleaningtypedescription" className='inputviewhistory' type='text' value={optionstypes[history.type] + " " + history.cleaningtypedescription} disabled style={history.roomnumber !== "default cleaningassignment" ? { visibility: "visible" } : { visibility: "hidden" }}>
                            </input>
                            <label className='labelhotel'>
                                {t('Supervisor')}
                            </label>
                            <input id="createdby" name="createdby" className='inputviewhistory' type='text' value={history.createdby} disabled>
                            </input>

                            <label className='labelhotel'>
                                {t('Cleaner')}
                            </label>
                            <input id="assignedto" name="assignedto" className='inputviewhistory' type='text' value={history.assignedto} disabled>
                            </input>

                            <label className='labelhotel'>
                                {t('Cleaningstarted')}
                            </label>
                            <input id="startTime" name="startTime" className='inputviewhistory' type='text' value={history.startTime} disabled>
                            </input>

                            <label className='labelhotel'>
                                {t('Cleaningstopped')}
                            </label>
                            <input id="stopTime" name="stopTime" className='inputviewhistory' type='text' value={history.stopTime} disabled>
                            </input>

                            <label className='labelhotel'>
                                {t('timespend')}
                            </label>
                            <input id="timespend" name="timespend" className='inputviewhistory' type='text' value={history.timespend} disabled>
                            </input>
                            <div>

                                <label className='labelhotel'>
                                    {t('Norm')}
                                </label>
                                <div className='payedtask_GoTasklist' style={Number(extratasksduration) === 0 ? { visibility: 'hidden' } : { visibility: 'visible' }} data-tooltip-id="overallpt" data-tooltip-content={extrataskdescription}>
                                    <GoTasklist /><Tooltip id="overallpt"></Tooltip>
                                </div>
                            </div>
                            <input id="norm" name="norm" className='inputviewhistory' type='number' value={history.roomnumber !== "default cleaningassignment" ? Number(Math.floor(history.norm) + extratasksduration).toFixed(0) : Number(history.extratime + extratasksduration).toFixed(0)} disabled>
                            </input>
                        </div>
                    </div>
                    <br></br>
                    <label id="noDND" className='labelhotel' style={history.dndTime === null ? { display: "block" } : { display: "none" }}>{t('NoDND')}</label>
                    <label id="dndtimegrouplabel" className='formtitleGroupBox formtitleGroupBoxtopmargin' style={history.dndTime === null ? { display: "none" } : { display: "grid" }}>{t('Do Not Disturbs')}</label>
                    <div id="dndtimegroup" className="AssignCleaninggroupboxhistory groupbox_history" style={history.dndTime === null ? { display: "none" } : { display: "grid" }}>
                        <div className='groupbox_history_4rows'>
                            <label className='labelhotel'>
                                {t('Time reported')}
                            </label>
                            <input id="dndtime" name="dndtime" className='inputviewhistory' type='text' value={history.dndTime} disabled>
                            </input>
                            <label className='labelhotel'>

                            </label>
                            <label className='labelhotel'>

                            </label>
                        </div>
                        <div className='groupbox_history_2rows'>
                            <label className='labelhotel'>
                                {t('DNDRemark')}
                            </label>
                            <textarea id="ReasonForDelete" className="inputviewhistory" type='text' name="deleteReason" value={history.DNDRemark} disabled>
                            </textarea>
                        </div>
                        <div className='groupbox_history_2rows'>
                            <ImageViewer imageArray={dndpicturenameArray} data={data} />
                        </div>

                    </div>


                    <label id="noissues" className='labelhotel' style={history.issue_id === null ? { display: "block" } : { display: "none" }}>{t('NoIssues')}</label>
                    <label id="issuestimegrouplabel" className='formtitleGroupBox' style={history.issue_id === null ? { display: "none" } : { display: "grid" }}>{t('reportIssue')}</label>
                    <div id="issuestimegroup" className="AssignCleaningformhistory groupbox_history" style={history.issue_id === null ? { display: "none" } : { display: "grid" }}>
                        <label className='labelhotel'>
                            {t('Description')}
                        </label>
                        <textarea id="issue_description" name="issue_description" className='inputviewhistory' type='text' value={history.issue_description} disabled>
                        </textarea>
                        <label className='labelhotel'>
                            {t('Oplossing')}
                        </label>
                        <textarea id="issue_resolution" name="issue_resolution" className='inputviewhistory' type='text' value={history.issue_resolution} disabled>
                        </textarea>
                        <label className='labelhotel'>
                            {t('Probleemopgelost')}
                        </label>
                        <input id="IssueResolvedchecked" name="IssueResolved" className="QAcheckbox" valueon="1" valueoff="0" checked={history.issue_resolved} value={history.issue_resolved} type='checkbox' disabled >
                        </input>
                        <p></p><p></p>
                        <p></p>
                        <ImageViewer imageArray={picturenameArray} data={data} />

                    </div>
                    <label id="noQA" className='labelhotel' style={history.QAopmerkingen === null ? { display: "block" } : { display: "none" }}>{t('Noqualityremarks')}</label>
                    <label id="QAtimegrouplabel" className='formtitleGroupBox' style={history.QAopmerkingen === null ? { display: "none" } : { display: "grid" }}>{t('Kwaliteitscontrole')}</label>
                    <div id="QAtimegroup" className="AssignCleaningformhistory groupbox_history" style={history.QAopmerkingen === null ? { display: "none" } : { display: "grid" }}>
                        <label className='labelhotel'>
                            {t('Opmerkingen')}
                        </label>
                        <textarea id="QAopmerkingen" name="QAopmerkingen" className='inputviewhistory' type='text' value={history.QAopmerkingen} disabled>
                        </textarea>
                        <label className='labelhotel'>
                            {t('Reclean')}
                        </label>
                        <input id="isReclean" name="isReclean" className="QAcheckbox" valueon="1" valueoff="0" checked={history.isReclean} value={history.isReclean} type='checkbox' disabled >
                        </input>
                        <ImageViewer imageArray={QApicturenameArray} data={data} />
                    </div>

                    <p></p>
                </div>
            </div>
        </>
    );
}
export default AssignmentDetailNode;
